import { CloudOff } from 'lucide-react'
import { Button } from '../Button/Button'
import { EmptyState } from '../EmptyState/EmptyState'

export type ErrorStateProps = {
  title?: string
  description?: string
  onRetry?: () => void
}

export function ErrorState({
  title = 'Não conseguimos carregar',
  description = 'Algo deu errado ao buscar os dados. Tente novamente.',
  onRetry,
}: ErrorStateProps) {
  return (
    <EmptyState
      tone="danger"
      icon={<CloudOff size={23} />}
      title={title}
      description={description}
      action={
        onRetry ? (
          <Button variant="text" size="sm" onClick={onRetry}>
            Tentar novamente
          </Button>
        ) : undefined
      }
    />
  )
}
